module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "acknowledgements"
    }
  }, [_c('h1', [_vm._v("Acknowledgements")]), _vm._v(" "), _c('p', [_vm._v("I am not a historian by any possible measure, but it is hoped that as an outsider, I have been able to highlight and explain important areas and connections. Needless to say, I have undoubtedly committed errors of both commission and omission, for which I can only crave the reader’s indulgence. I owe considerable thanks to my ever-willing secretary, Kath Leckey, and considerable apologies to my long-suffering wife, Jenna. Thanks are also due to many helpful friends, including Juliet Horne, John Barnett, John Adams, and my informal English teacher, Geraldine Wall. John Leatherdale took the excellent cover photograph of Richard I outside the Houses of Parliament. I am particularly grateful to my digital wizard, Ben Plewes for advice and rescue when my electronic inadequacies have been exposed.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a817782","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch004.vue
// module id = 72
// module chunks = 0